module.exports = __webpack_public_path__ + "img/game2.2.587fbb4c.png";